import { AxiosResponse } from "axios";
import axiosInstance from "@/axiosConfig";
import type { UserData } from "@/features/auth/types/auth.types";
import type { Representative } from "@/shared/types/representative.types";
import type { RepresentativeUpdateResponse } from "@/shared/types/user.types";

export const getCurrentUser = async (): Promise<AxiosResponse<UserData>> =>
  axiosInstance.get("/representatives/me");

export const updateCurrentUser = async (
  representativeId: string,
  data: Partial<Representative>,
): Promise<AxiosResponse<RepresentativeUpdateResponse>> =>
  axiosInstance.put(`/representatives/${representativeId}`, data);
